import { GridProps } from '@mui/material';
import { MouseEventHandler, ReactNode } from 'react';

export interface HeaderBasicProps {
  headerTitle?: string;
  subTitle?: string;
  headerDetails?: ReactNode;
  gridHeaderClass?: string;
  onClickCreate?: MouseEventHandler;
  createButtonText?: string;
  isShowButton?: boolean;
  gridChildrenProps?: GridProps;
  justifyContent?: GridProps['justifyContent'];
  alignItems?: GridProps['alignItems'];
}

export const DefaultProps = {
  headerTitle: '',
  subTitle: undefined,
  headerDetails: undefined,
  gridHeaderClass: '',
  isShowButton: true
};
